export default {
    accountManagement: 'Accounts',
    userManagement: 'Users',

    lockNavigation: 'Lock navigation',
    unlockNavigation: 'Unlock navigation',

    sidebar: {
        webOrderBadgeTooltip: 'Active pending web order | Active pending web orders',
        activityReport: '@:dashboards.activityReport',
        allLead: '@:dashboards.allLead',
        automations: 'Automations',
        campaign: 'Campaign',
        commercial: 'F&I',
        duplicates: 'Duplicates',
        event: '@:dashboards.event',
        flow: 'Flow',
        headers: {
            client: 'Client',
            tools: 'Tools',
            management: 'Management',
        },
        homepage: 'Homepage',
        import: 'Import',
        inventory: 'Inventory',
        inTurn: "Who's Next",
        analytics: 'Analytics',
        leadXpress: '@:dashboards.leadXpress',
        loyalty: '@:dashboards.loyalty',
        niotext: 'Niotext',
        objectives: 'Objectives',
        phoneUp: '@:dashboards.phoneUp',
        renewal: '@:dashboards.renewal',
        templates: 'Templates',
        saleTable: '@:dashboards.saleTable',
        schedule: 'Schedule',
        service: '@:dashboards.service',
        sms: 'SMS',
        smsBadgeTooltip: 'Unread message | Unread messages',
        trash: 'Trash',
        walkIn: '@:dashboards.walkIn',
        webBoost: '@:dashboards.webBoost',
        webOrder: '@:dashboards.webOrder',
    },
    supportModal: {
        title: 'Support',
        contactPre: 'If you have any questions, feel free to reach out to our team',
        contactMid: 'or call our toll-free number at',
        contactPhone: '1-866-430-6767',
        contactPost: ". We'd be happy to help.",
        trainingPre: 'Would you like to get more out of Activix CRM? Take the next step with',
        trainingLink: 'Activix EXP',
        youtubePre: 'Check out our',
        youtubeLink: 'YouTube channel',
        youtubePost: ", where you'll find tutorials and best practice tips.",
        linkedinPre: 'Want to read more content about the automotive industry? Visit our',
        linkedinLink: 'LinkedIn page',
    },
    userDropdown: {
        accounts: 'Accounts',
        changelog: 'Changelog',
        disconnect: 'Sign out',
        groups: 'Groups',
        training: 'Training',
        help: 'Help',
        myAccount: 'My account',
        myProfile: 'My profile',
        suggestions: 'Suggestions',
        users: 'Users',
        turnOffNotifications: 'Suspend notifications',
        turnOffNotificationsDetails:
            'Do you want to suspend the reception of notification and redirect them to your screen?',
        turningOnNotifications: 'Notifications have been turned on',
    },
};
